// extracted by mini-css-extract-plugin
export default {"container":"getStarted_container__JYVcs","sectionHeading":"getStarted_sectionHeading__7uiWN","sectionInfo":"getStarted_sectionInfo__Y6svb","itemTitle":"getStarted_itemTitle__jRKYF"};